export default __webpack_public_path__ + "static/media/pixil-gif-drawing.0e662c3d.gif";